type LandingEvent =
  | { action: 'hero_search'; query: string }
  | { action: 'category_click'; venueType: string }
  | { action: 'venue_card_click'; venueType: string }
  | { action: 'cta_click'; variant: 'vendor' | 'customer' }
  | { action: 'mobile_sticky_click' };

export function useLandingAnalytics() {
  const track = (event: LandingEvent) => {
    // TODO: Wire to GA4/Mixpanel when analytics infrastructure is ready
    if (import.meta.env.DEV) {
      console.debug('[landing-analytics]', event);
    }
  };

  return { track };
}
